<template>
	<div class="avaunique">
		<div class="avaunique__head">
			<span class="avaunique__head__back" @click="closeDrawer">
				<span class="avaunique__head__back__icon">
					<svg viewBox="0 0 50 50">
						<use xlink:href="#icon--back" width="100%" height="100%"></use>
					</svg>
				</span>
				<span class="avaunique__head__back__label">
					{{ $t('common.back') }}
				</span>
			</span>
		</div>
		<div class="avaunique__box">
			<div class="avaunique__box__head">
				<span class="avaunique__box__head__back" @click="closeModal">
					<span class="avaunique__head__back__icon">
						<svg viewBox="0 0 50 50">
							<use xlink:href="#icon--back" width="100%" height="100%"></use>
						</svg>
					</span>
					<span class="avaunique__head__back__label">
						{{ $t('common.back') }}
					</span>
				</span>
			</div>
			<div class="avaunique__box__content uniquebox">
				<div class="uniquebox__head">
					<span class="uniquebox__icon">
						<small class="uniquebox__icon__circle"></small>
						<small class="uniquebox__icon__circle"></small>
						<small class="uniquebox__icon__circle"></small>
					</span>
					<span class="uniquebox__title">
						{{ $t('availabilities.box.unique.title') }}
					</span>
					<small class="uniquebox__text" v-html="$t('availabilities.box.unique.text')"></small>
				</div>
				<div class="uniquebox__content">
					<UniqueForm v-if="gid" :gid="gid" :isedit="isEdit" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { EventBus } from '@/events_bus.js';
import dayjs from 'dayjs';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/all';
gsap.registerPlugin(CustomEase);

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const { CalendarPanel } = DatePicker;

import Spinner from '@/views/components/common/Spinner';

import UniqueForm from '@/views/components/garages/availabilities/UniqueForm';

export default {
	name: 'Unique',
	props: {
		mode: {
			type: String,
			required: true,
			default: 'mobile',
		},
		gid: {
			required: false,
		}
	},
	components: {
		DatePicker,
		CalendarPanel,
		Spinner,
		UniqueForm
	},
	data() {
		return {
			info: null,
			isEdit: false,
			fromdate: new Date().valueOf(),
			todate: new Date().valueOf(),
			fromtime: null,
			totime: null,
			addTime: false,
			isEdit: false,
			showrepeats: false,
			form: {
				start_at: null,
				end_at: null,
				price: 0,
				price_hour: 1,
				single_booking: false,
				garage_id: null,
				range: false,
				repeat: "DAY",
				repeat_number: 1,
			},
			lang: {
				months: ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],
				days: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
			},
		}
	},
	watch: {
		avatype: {
			handler(newval, oldval) {
				this.avatypeHandler(newval);
			}
		},
		isEdit: {
			handler(newval, oldval) {
				return newval;
			}
		}
	},
	methods: {
		openModal() {
			gsap.timeline({
				onComplete: () => {
					gsap.set('.avaunique', {
						pointerEvents: 'all'
					})
				}
			})
				.to('.avaunique', {
					duration: 0.3,
					opacity: 1
				})
				.to('.avaunique__box', {
					duration: 0.3,
					y: '0%',
					opacity: 1
				})
		},
		closeModal() {
			EventBus.$emit('availability-form', this.info);
			gsap.timeline({
				onComplete: () => {
					gsap.set('.avaunique', {
						pointerEvents: 'none'
					})
				}
			})
			.to('.avaunique__box', {
				duration: 0.3,
				y: 150,
				opacity: 0
			})
			.to('.avaunique', {
				duration: 0.3,
				opacity: 0
			})
		},
		openDrawer() {
			gsap.to('.avaunique', {
				duration: 0.9,
				x: '0%',
				ease: CustomEase.create("custom", "M0,0 C0.726,0 0,1 1,1 "),
				onComplete: () => {
					gsap.set('.avaunique', {
						pointerEvents: 'all'
					})
				}
			})
		},
		closeDrawer() {
			EventBus.$emit('availability-form', this.info);
			gsap.to('.avaunique', {
				duration: 0.9,
				x: '100%',
				ease: CustomEase.create("custom", "M0,0 C0.726,0 0,1 1,1 ")
			})
		},
		init() {
			
		}
	},
	mounted() {
		this.init();
	},
	created() {
		EventBus.$on('open-unique', (info) => {
				this.info = info;
				this.isEdit = info.isedit;
				if(this.mode == 'mobile') {
					this.openDrawer()
				} else {
					this.openModal();
				}
			});
		
			EventBus.$on('close-avaform', info => {
				if(this.mode == 'mobile') {
					this.closeDrawer()
				} else {
					this.closeModal();
				}
			});
		
			EventBus.$on('return-to-list', () => {
				if(this.mode == 'mobile') {
					this.closeDrawer()
				} else {
					this.closeModal();
				}
			});
	},
	destroyed() {
		EventBus.$off('open-unique');
		EventBus.$off('close-avaform');
		EventBus.$off('return-to-list');
	}
}
</script>
<style lang="scss">
.avaunique {
	--select: 100px;
	@extend %flexCenterCenter;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: $color-seasalt;
	z-index: 10000;
	display: block;
	overflow: hidden;
	transform: translateX(100%);
	pointer-events: none;
	&__head {
		@extend %flexCenterStart;
		@include size(100%, var(--headDrawer));
		padding: 0 var(--gutter);
		position: relative;
		z-index: 100;
		&__back {
			@extend %flexCenterStart;
			width: calc(100% - var(--btn));
			cursor: pointer;
			&__icon {
				@extend %flexCenterCenter;
				@include size(var(--smallicon),var(--smallicon));
				svg {
					display: block;
					@include size(75%,75%);
					fill: $color-black;
				}
			}
			&__label {
				@extend %text-15;
				display: block;
				width: max-content;
				font-variation-settings: 'wght' 600;
				padding-left: var(--minigutter);
			}
		}
	}
	&__box {
		@extend %panel;
		background: transparent;
		padding: 0;
		height: calc(100svh - var(--headDrawer));
		overflow: hidden;
		position: relative;
		z-index: 100;
		&__head {
			@extend %flexCenterBetween;
			width: 100%;
			display: none;
			margin-bottom: var(--gutter);
			position: relative;
			z-index: 100;
			&__title {
				@extend %text-33;
				display: block;
				width: 100%;
				font-family: $font-manrope;
				font-variation-settings: 'wght' 700;
			}
			&__back {
				@extend %flexCenterStart;
				width: calc(100% - var(--btn));
				cursor: pointer;
				&__icon {
					@extend %flexCenterCenter;
					@include size(var(--smallicon),var(--smallicon));
					svg {
						display: block;
						@include size(75%,75%);
						fill: $color-black;
					}
				}
				&__label {
					@extend %text-15;
					display: block;
					width: max-content;
					font-variation-settings: 'wght' 600;
					padding-left: var(--minigutter);
				}
			}
		}
		&__content {
			display: block;
			@include size(100%,100%);
			overflow: auto;
			overflow-x: hidden;
		}
	}
	&__label {
		display: block;
		width: 100%;
		&__text {
			display: block;
			width: 100%;
		}
	}
	&__button {
		width: 100%;
		text-align: center;
		margin-bottom: var(--gutter);
		cursor: pointer;
		&.filled {
			background: $color-blue;
			color: $color-white;
		}
		&.outline {
			border-color: $color-blue;
			color: $color-blue
		}
	}
	&__loading {
		position: absolute;
		top: 0;
		left: 0;
		@extend %flexCenterCenter;
		background: rgba($color-white, 0.86);
		@include size(100%,100%);
		pointer-events: all;
		z-index: 100;
		&__spinner {
			display: block;
			margin-bottom: var(--gutter);
			&__box {
				display: block;
				@include size(65px,65px);
				margin: 0 auto var(--gutter);
			}
			&__label {
				@extend %text-15;
				display: block;
				width: 100%;
				font-family: $font-manrope;
				font-variation-settings: 'wght' 600;
				text-align: center;
			}
		}
	}
	&__success {
		@extend %flexCenterCenter;
		flex-direction: column;
		text-align: center;
		&__icon {
			@extend %flexCenterCenter;
			background: $color-error;
			@include size(var(--supergutter),var(--supergutter));
			border-radius: 100%;
			margin-bottom: var(--gutter);
			overflow: hidden;
			svg {
				display: block;
				@include size(var(--smallicon),var(--smallicon));
				fill: $color-white;
			}
		}
		&__label {
			display: block;
			padding: var(--gutter) var(--supergutter);
			&__txt {
				display: block;
				width: 100%;
				@extend %text-33;
				font-variation-settings: 'wght' 700;
				color: $color-error;
				margin-bottom: var(--gutter);
			}
			&__btn {
				width: max-content;
				padding: 0 var(--supergutter);
				margin: 0 auto;
				background: $color-blue;
				color: $color-white;
			}
		}
		&.success {
			.avaunique__success {
				&__icon {
					background: $color-success;
				}
				&__label {
					&__txt {
						color: $color-success;
					}
				}
			}
		}
	}
	&__actions {
		@extend %flexCenterEnd;
		background: $color-white;
		width: 60%;
		&__btn {
			@extend %flexCenterCenter;
			border-radius: calc(var(--bigradius) / 2);
			border: 1px solid $color-silver;
			box-shadow: $shadow;
			padding: var(--thirdgutter) var(--minigutter);
			margin-left: var(--minigutter);
			&__icon {
				@extend %flexCenterCenter;
				@include size(var(--minigutter),var(--minigutter));
				svg {
					display: block;
					@include size(100%,100%);
					fill: $color-black;
				}
				&.close svg {
					transform: rotate(45deg);
				}
			}
			&__label {
				margin-left: var(--thirdgutter);
				display: none;
			}
		}
	}
	&__save {
		display: block;
		width: 100%;
		padding: var(--gutter) 0;
		&__btn {
			display: block;
			background: $color-blue;
			color: $color-white;
			font-variation-settings: 'wght' 700;
			margin: 0 auto;
		}
	}
	@media (min-width: $from-large) {
		display: flex;
		background: rgba($color-black, 0.1);
		transform: translateX(0%);
		opacity: 0;
		&__head {
			display: none;
		}
		&__box {
			background: $color-white;
			height: 82vh;
			max-width: 780px;
			width: 100%;
			// height: calc(100% - var(--headDrawer));
			padding: var(--gutter);
			transform: translateY(150px);
			opacity: 0;
			&__head {
				display: flex;
				margin-bottom: var(--thirdgutter);
			}
			&__text {
				font-size: 0.938rem;
			}
		}
		&__button {
			margin-bottom: 0;
		}
		&__actions {
			&__btn {
				&__label {
					display: block;
				}
			}
		}
		&__save {
			display: none;
		}
		&__success {
			&__label {
				margin: 0 auto;
				max-width: 75%;
			}
		}
	}

	.uniquebox {
		padding: 0 var(--minigutter);
		&__head {
			@extend %flexCenterStart;
			flex-wrap: wrap;
			width: 100%;
			margin: var(--gutter) 0;
			padding: 0 var(--minigutter);
		}
		&__icon {
			@extend %flexCenterStart;
			width: max-content;
			&__circle {
				display: block;
				@include size(12px, 12px);
				border-radius: 100%;
				border: 3px solid $color-blue;
				&:nth-child(2) {
					margin: 0 2px;
				}
			}
		}
		&__title {
			display: block;
			width: max-content;
			@extend %text-20;
			font-family: $font-manrope;
			font-variation-settings: 'wght' 700;
			color: $color-blue;
			padding-left: var(--thirdgutter);
		}
		&__text {
			display: block;
			width: 100%;
			margin-top: var(--thirdgutter);
		}
	}
}
</style>